<template>
    <div class="flex">
        <button type="button" class="btn btn-default btn-number remove-product" data-type="minus" @click="decrement" :disabled="quantity <= min">
            <span class="glyphicon glyphicon-minus"></span>
        </button>
        <input class="form-control input-number space-bottom-0" type="number" :min="min" :max="max" v-model.number="quantity">
        <button type="button" class="btn btn-default btn-number add-product" data-type="plus" @click="increment" :disabled="quantity >= max || maxedOut">
            <span class="glyphicon glyphicon-plus"></span>
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            max: {
                type: Number,
            },
            min: {
                type: Number,
                default: 0
            },
            default: {
                type: Number,
            },
            maxedOut: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                quantity: this.default,
            }
        },

        methods: {
            increment: function () {
                let maxExceeded = (this.quantity + 1) > this.max;
                if (!maxExceeded) {
                    this.quantity++;
                }
            },
            decrement: function() {
                if (this.quantity > this.min) {
                    this.quantity--;
                }
            },
            reset() {
                this.quantity = 0;
            }
        },
        watch: {
            quantity(selectedQuantity) {
                this.quantity = Math.abs(this.quantity);
                this.$emit("setProductQuantity", Math.abs(selectedQuantity));
            }
        }
    }
</script>

<style scoped>

    .flex {
        display: flex;
    }

    .flex button:disabled {
        border: 1px solid #EEEEEE;
        background-color: #F6F7F9;
    }

    .flex button:disabled span {
        color: #C1C9D1;
    }

    .flex button[disabled] {
        border: 1px solid #EEEEEE;
        background-color: #F6F7F9;
    }

    .flex button[disabled] span {
        color: #C1C9D1;
    }

    .form-control {
        box-shadow: none;
    }

    .input-number {
        text-align: center;
        border: 1px solid #f0f0f0;
        min-width: 40px;
        max-width: 50px;
    }

    .remove-product {
        background-color: #0384fb;
        margin-right: 10px;
    }

    .remove-product span {
        color: white;
    }

    .add-product {
        background-color: #0384fb;
        margin-left: 10px;
        border: none;
    }

    .glyphicon {
        top: 2px;
    }

    .glyphicon-plus {
        left: 1px;
    }

    .glyphicon-minus {
        color: #C1C9D1;
        right: 1px;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }


</style>